import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from 'react';
import { Box } from '../../../../../layout/Box';
import { DROPDOWN_PADDING } from '../../..';
import { Text } from '../../../../../typography/Text';
import styled from 'styled-components';

var ListItem =
/** @class */
function (_super) {
  __extends(ListItem, _super);

  function ListItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.defaultRenderer = function (_a) {
      var disabled = _a.disabled,
          isSelected = _a.isSelected,
          label = _a.label;
      return React.createElement(Text, {
        color: disabled ? Text.Color.Gray3 : Text.Color.Dark,
        weight: isSelected ? Text.Weight.Bold : Text.Weight.Normal
      }, label);
    };

    return _this;
  }

  ListItem.prototype.render = function () {
    var _a = this.props,
        disabled = _a.disabled,
        url = _a.url,
        isSelected = _a.isSelected,
        onSelect = _a.onSelect;
    var itemContents = (this.props.itemRenderer || this.defaultRenderer)(this.props);
    return isSelected ? React.createElement(Box, {
      ph: DROPDOWN_PADDING,
      pv: DROPDOWN_PADDING / 2
    }, itemContents) : React.createElement(StyledListItem, {
      disabled: disabled,
      href: disabled ? undefined : url,
      onClick: disabled ? undefined : onSelect
    }, itemContents);
  };

  return ListItem;
}(React.Component);

export { ListItem };
var StyledListItem = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n    cursor: ", ";\n    padding: ", ";\n    pointer-events: auto;\n    text-decoration: none;\n"], ["\n    display: block;\n    cursor: ", ";\n    padding: ", ";\n    pointer-events: auto;\n    text-decoration: none;\n"])), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.theme.units.getValues([DROPDOWN_PADDING / 2, DROPDOWN_PADDING]);
});
var templateObject_1;